import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { DataStorageService } from '../../data-storage.service';
import { Device } from '../../../models/device';
import { ConfigService } from '../../config.service';
import { SecurityService } from '../../security.service';
import { ApiService } from '../../api.service';
import { AvailableComponents } from '../../side-bar/enumAvailableComponents';

@Component({
  selector: 'app-manage-my-devices',
  templateUrl: './manage-my-devices.component.html',
  styleUrls: ['./manage-my-devices.component.scss']
})
export class ManageMyDevicesComponent implements OnInit, AfterContentInit, OnDestroy {

  activeTab: string;
  activeTabId: number;

  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    public configService: ConfigService,
    public api: ApiService) {
    this.activeTab = dataStorageService.categories[0].name;
    this.activeTabId = dataStorageService.categories[0].id;
    this.dataStorageService.currentCategoryName = this.activeTab;
    this.dataStorageService.currentCategoryId = this.activeTabId;
    this.dataStorageService.devices = [];
  }


  ngOnInit() {
    const element = document.getElementById('myMgnt');
    element.classList.add('active');
    const partnerId = this.securityService.authorization.user.partnerId;
    this.api.getDevices(partnerId, this.dataStorageService.categories[0].id).then((data) => {
      this.dataStorageService.devices = data;
    });
  }
  ngOnDestroy() {
    const element = document.getElementById('myMgnt');
    element.classList.remove('active');
  }

  ngAfterContentInit() {
    this.dataStorageService.currentComponent = AvailableComponents.ManageMyDevices;
  }

  tabClick(tab: string, tabId?: number) {
    const partnerId = this.securityService.authorization.user.partnerId;
    this.api.getDevices(partnerId, tabId, false).then((data) => {
      this.dataStorageService.devices = data;
      this.activeTab = tab;
      this.dataStorageService.editedDevice.categoryId = tabId;
      this.dataStorageService.currentCategoryId = tabId;
    });
    this.dataStorageService.currentCategoryName = tab;
  }

  addNewDevice() {
    this.dataStorageService.from = 'ADD';
    this.dataStorageService.editedDevice = new Device();
  }
}



// WEBPACK FOOTER //
// ./src/app/content/manage-my-devices/manage-my-devices.component.ts